export class CajasTextos {

  constructor(
    public username: string,
    public pass:string
  ){}

}

export class BtnLogin {
  constructor(
    public inicia:string

  ){}
}

export class Etiquetas {
  constructor(
    public LabelTitulo:string,
    public labelUsuario:string,
    public labelPass:string
  )
  {}

}
export class LoginData{
  constructor(
    public usuario: string,
    public pass: string
  ){}
}
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/